<template>
  <div class="view">
    <v-container fluid>
      <v-row>
        <v-col class="col-md-4">
          รายงานยอดขายตามวันสั่ง
          <hr/>
          <router-link to="/report/sale_so_far">รายงานยอดขายเดือนนี้</router-link>
          <br/>
          <router-link to="/report/sale_so_far/month/previous">รายงานยอดขายเดือนที่แล้ว</router-link>
          <br/>

        </v-col>

        <v-col class="col-md-4">
          รายงานยอดชำระ
          <hr/>
          <router-link to="/report/receipt_so_far">รายงานยอดชำระเดือนนี้</router-link>
          <br/>
          <router-link to="/report/receipt_so_far/month/previous">รายงานยอดชำระเดือนที่แล้ว</router-link>
          <br/>
          <router-link to="/report/slip">รายการจ่ายค่าคอมฯ</router-link>
          <br/>

        </v-col>
        <v-col class="col-md-4">
          รายงาน slip จ่ายค่าคอมฯ
          <hr/>
          <span style="font-size: 0.8em;line-height: 2.0;font-weight: lighter;color: #999;padding-bottom: 6px;display: inline-block;">คำนวนทุกวันที่ 22 เวลา 02:00</span>
          <br/>
          <a :href="'/api/reports/slip_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/slip_sum_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months_with_future"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <router-link to="/report/slip">รายการจ่ายค่าคอมฯ</router-link>
          <br/>


        </v-col>
      </v-row>

      <v-row>


      </v-row>

      <v-row v-if="$store.state.$user.role<=UserConst.ROLE_MARKETING">
        <v-col class="col-md-4">
          รายงาน ยอดขายธุรกิจ
          <hr/>

          <br/>
          <a :href="'/api/reports/commission_by_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/commission_sum_by_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/commission_by_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนนี้</a> |
          <a :href="'/api/reports/commission_sum_by_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">l
            สรุป
          </a>

          <br/>
          <a :href="'/api/reports/commission_by_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนที่แล้ว</a> |
          <a :href="'/api/reports/commission_sum_by_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>


        </v-col>

        <v-col class="col-md-4">
          รายงาน manager ยอดชำระธุรกิจ
          <hr/>

          <br/>
          <a :href="'/api/reports/receipt_by_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/receipt_sum_by_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/receipt_by_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดชำระเดือนนี้</a> |
          <a :href="'/api/reports/receipt_sum_by_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">l
            สรุป
          </a>

          <br/>
          <a :href="'/api/reports/receipt_by_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดชำระเดือนที่แล้ว</a> |
          <a :href="'/api/reports/receipt_sum_by_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>


        </v-col>

        <v-col class="col-md-4">
          รายงาน manager ยอดขายจังหวัด
          <hr/>

          <br/>
          <a :href="'/api/reports/sale_by_province_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >ย่อย
            </v-btn>
          </a>
          <a :href="'/api/reports/sale_sum_by_province_business?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>หลัก</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/sale_by_province_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนนี้</a> |
          <a :href="'/api/reports/sale_sum_by_province_business?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">l
            สรุป
          </a>

          <br/>
          <a :href="'/api/reports/sale_by_province_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนที่แล้ว</a> |
          <a :href="'/api/reports/sale_sum_by_province_business?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>


        </v-col>
      </v-row>

      <v-row v-if="$store.state.$user.role<=UserConst.ROLE_MARKETING">
        <v-col class="col-md-4">
          รายงาน admin ยอดขาย
          <hr/>
          <br/>
          <a :href="'/api/reports/commission_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/commission_sum_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/commission_by_sale?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนนี้</a> |
          <a :href="'/api/reports/commission_sum_by_sale?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">l
            สรุป
          </a>

          <br/>
          <a :href="'/api/reports/commission_by_sale?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนที่แล้ว</a> |
          <a :href="'/api/reports/commission_sum_by_sale?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>


        </v-col>
        <v-col class="col-md-4">
          รายงาน admin ยอดชำระ
          <hr/>
          <br/>
          <a :href="'/api/reports/receipt_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/receipt_sum_by_sale?from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/receipt_by_sale?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดชำระเดือนนี้</a> |
          <a :href="'/api/reports/receipt_sum_by_sale?from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>
          <a :href="'/api/reports/receipt_by_sale?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดชำระเดือนที่แล้ว</a> |
          <a :href="'/api/reports/receipt_sum_by_sale?from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>

          <br/>


        </v-col>
        <v-col class="col-md-4">
          รายงาน ปัญหาข้อมูล
          <hr/>
          <br/>
          <a :href="'/api/reports/non_paid_by_disabled_sale?token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            ออเดอร์ไม่มี sales ตาม
          </a><br/>
          <a :href="'/api/reports/customers/non_valid?token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            ข้อมูลลูกค้าไม่สมบูรณ์
          </a><br/>
          <a :href="'/api/reports/products/non_valid?token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            ข้อมูลสินค้าไม่สมบูรณ์
          </a><br/>

          <a v-if="$store.state.$user.role<=UserConst.ROLE_ADMIN"
             :href="'/api/reports/admin/line_not_added?token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            ผู้ใช้ไม่ add line
          </a><br/>


        </v-col>
      </v-row>

      <v-row>
        <v-col class="col-md-4" v-if="$store.state.$user.role<=UserConst.ROLE_MARKETING">
          รายงาน OFM ยอดขาย
          <hr/>
          <br/>
          <a :href="'/api/reports/commission_by_sale?docbook=SOOEQ&from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/commission_sum_by_sale?docbook=SOOEQ&from_date='+commission_sum_by_business_month[0]+'&to_date='+commission_sum_by_business_month[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month"
              :items="months"
              class="select-no-message"
              label="เดือน"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
          <a :href="'/api/reports/commission_by_sale?docbook=SOOEQ&from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนนี้</a> |
          <a :href="'/api/reports/commission_sum_by_sale?docbook=SOOEQ&from_date='+monthCurrentDateFrom+'&to_date='+monthCurrentDateTo+'&token='+$helper.access_token()"
             target="_blank">l
            สรุป
          </a>

          <br/>
          <a :href="'/api/reports/commission_by_sale?docbook=SOOEQ&from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            ยอดขายเดือนที่แล้ว</a> |
          <a :href="'/api/reports/commission_sum_by_sale?docbook=SOOEQ&from_date='+monthPreviousDateFrom+'&to_date='+monthPreviousDateTo+'&token='+$helper.access_token()"
             target="_blank">
            สรุป
          </a>
          <br/>


        </v-col>
        <v-col class="col-md-4" v-if="$store.state.$user.role<=UserConst.ROLE_MARKETING">
          รายงานโปรโมชั่น
          <hr/>
          <br/>
          <a :href="'/api/reports/promotion_by_campaign?from_date='+commission_sum_by_business_month_from[0]+'&to_date='+commission_sum_by_business_month_to[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn class="ma-2"
            >เปิด
            </v-btn>
          </a>
          <a :href="'/api/reports/promotion_sum_by_campaign?from_date='+commission_sum_by_business_month_from[0]+'&to_date='+commission_sum_by_business_month_to[1]+'&token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            <v-btn>สรุป</v-btn>
          </a>
          <v-select
              v-model="commission_sum_by_business_month_from"
              :items="months_with_current"
              class="select-no-message"
              label="ตั้งแต่"
              outlined
              style="float: left;width: 120px"
          ></v-select>
          <v-select
              v-model="commission_sum_by_business_month_to"
              :items="months_with_current"
              class="select-no-message"
              label="ถึง"
              outlined
              style="float: left;margin-left:8px;width: 120px"
          ></v-select>
          <div style="clear: both;margin: 0;padding: 0"></div>
        </v-col>
        <v-col class="col-md-4">
          ลิ้งอื่นๆ
          <hr/>
          <template v-if="$store.state.$user.role<=UserConst.ROLE_ADMIN || $store.state.$user.employee_code==='0090'">
            <a href="https://overdue-reports.spacleanthailand.com"
               style="text-decoration: none" target="_blank">
              รายการลูกหนี้ค้างชำระรายเซลล์
            </a><br/>
          </template>

          <a :href="'/api/reports/product_best_selling?token='+$helper.access_token()"
             style="text-decoration: none" target="_blank">
            สินค้าขายดี
          </a><br/>

          <a href="https://docs.google.com/spreadsheets/d/1Wrer5rVMj_7cEqvSzFz-YUxIijTP83W-JqXTdVp3lE8/edit#gid=0"
             style="text-decoration: none" target="_blank">
            รายการสินค้าสำหรับสนับสนุนการขาย
          </a><br/>
          <a href="https://docs.google.com/spreadsheets/d/1gS05W5w_w0COI-3iWrcvh_IEEjp7uzdNQpAC-1-JGk4/edit?gid=1202213373#gid=1202213373"
             style="text-decoration: none" target="_blank">
            SO ค้างส่ง
          </a><br/>


        </v-col>
      </v-row>


    </v-container>
  </div>
</template>
<style lang="scss" scoped>

.view {
  font-size: 18px;
}

.right-box {
  height: 30vh;
}

.right-col {
  padding-top: 0;
  padding-bottom: 0;
}

.right-container {
  padding: 0;
}

.bold {
  font-weight: bold;
}

.overview-list {
  background: transparent;
}

</style>
<script lang="ts">

import {UserConst} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy}
})
export default class ViewReport extends Vue {
  UserConst = UserConst
  monthCurrentDateFrom = ''
  monthCurrentDateTo = ''
  monthPreviousDateFrom = ''
  monthPreviousDateTo = ''
  months = [{text: 'สค. 63', value: ['', '']}]
  months_with_current = [{text: 'สค. 63', value: ['', '']}]
  months_with_future = [{text: 'สค. 63', value: ['', '']}]

  commission_sum_by_business_month_from = ['2020-06-01', '2020-06-30']
  commission_sum_by_business_month_to = ['2020-06-01', '2020-06-30']
  commission_sum_by_business_month = ['2020-06-01', '2020-06-30']

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  mounted() {


    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.monthPreviousDateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.monthPreviousDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.monthCurrentDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.monthCurrentDateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)


    this.commission_sum_by_business_month = [
      this.monthPreviousDateFrom, this.monthPreviousDateTo
    ]

    this.commission_sum_by_business_month_from = [
      this.monthPreviousDateFrom, this.monthPreviousDateTo
    ]

    this.commission_sum_by_business_month_to = [
      this.monthCurrentDateFrom, this.monthCurrentDateTo
    ]


    var firstOfMonth = tmpDateFrom
    var dateSpin = new Date('2020-06-01')

    this.months = []
    this.months_with_current = []
    this.months_with_future = []
    while (dateSpin <= firstOfMonth) {
      dateSpin.setMonth(dateSpin.getMonth() + 1)

      var tmpDateFrom = new Date(dateSpin)
      tmpDateFrom.setDate(0)
      const tmpMonthPreviousDateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
      tmpDateFrom.setDate(1)
      const tmpMonthPreviousDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

      this.months.push({
        text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
            [
              tmpMonthPreviousDateFrom,
              tmpMonthPreviousDateTo
            ]
      })
      this.months_with_current.push({
        text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
            [
              tmpMonthPreviousDateFrom,
              tmpMonthPreviousDateTo
            ]
      })

      this.months_with_future.push({
        text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
            [
              tmpMonthPreviousDateFrom,
              tmpMonthPreviousDateTo
            ]
      })


    }

    dateSpin.setMonth(dateSpin.getMonth() + 1)

    var tmpDateFrom2 = new Date(dateSpin)
    tmpDateFrom2.setDate(0)
    tmpDateFrom2.setDate(1)
    const tmpMonthPreviousDateFrom = (new Date(tmpDateFrom2.getTime() - tzoffset)).toISOString().substr(0, 10)

    this.months_with_current.push({
      text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
          [
            this.monthCurrentDateFrom,
            this.monthCurrentDateTo
          ]
    })

    var now = new Date()
    var nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    if (now.getMonth() == 11) {
      nextMonth = new Date(now.getFullYear() + 1, 0, 1)
    }
    var nextMonthEnd = new Date(now.getFullYear(), now.getMonth() + 2, 0)
    if (now.getMonth() == 10) {
      nextMonthEnd = new Date(now.getFullYear() + 1, 0, 0)
    }
    var currentMonthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0)
    if (now.getMonth() == 11) {
      currentMonthEnd = new Date(now.getFullYear() + 1, 0, 0)
    }
    const monthEndDateFrom = (new Date(currentMonthEnd.getTime() - tzoffset)).toISOString().substr(0, 10)
    const tmpMonthNextDateFrom = (new Date(nextMonth.getTime() - tzoffset)).toISOString().substr(0, 10)
    const monthNextDateFrom = (new Date(nextMonth.getTime() - tzoffset)).toISOString().substr(0, 10)
    const monthNextDateTo = (new Date(nextMonthEnd.getTime() - tzoffset)).toISOString().substr(0, 10)

    // this.months_with_future.push({
    //   text: this.$helper.month_format_short(tmpMonthPreviousDateFrom), value:
    //       [
    //         this.monthCurrentDateFrom,
    //         monthEndDateFrom
    //       ]
    // })

    this.months_with_future.push({
      text: this.$helper.month_format_short(tmpMonthNextDateFrom), value:
          [
            monthNextDateFrom,
            monthNextDateTo
          ]
    })


  }

}
</script>
